import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { text: String }
  
  connect() {
    console.log('📋 Clipboard Controller connected')
  }
  
  copy() {
    const textToCopy = this.textValue
    
    if (!textToCopy) {
      console.error('No text to copy')
      return
    }
    
    // Use the modern Clipboard API
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(textToCopy).then(() => {
        this.showFeedback('Link copied to clipboard!')
      }).catch(err => {
        console.error('Failed to copy with Clipboard API:', err)
        this.fallbackCopy(textToCopy)
      })
    } else {
      this.fallbackCopy(textToCopy)
    }
  }
  
  fallbackCopy(text) {
    // Fallback method for older browsers
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.left = '-999999px'
    textArea.style.top = '-999999px'
    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()
    
    try {
      const successful = document.execCommand('copy')
      if (successful) {
        this.showFeedback('Link copied to clipboard!')
      } else {
        this.showFeedback('Failed to copy link', 'error')
      }
    } catch (err) {
      console.error('Fallback copy failed:', err)
      this.showFeedback('Copy not supported', 'error')
    }
    
    document.body.removeChild(textArea)
  }
  
  showFeedback(message, type = 'success') {
    // Create temporary feedback element
    const feedback = document.createElement('div')
    feedback.className = `fixed top-4 right-4 z-50 px-3 py-2 rounded-lg text-xs font-medium transition-all duration-300 ${
      type === 'success' 
        ? 'bg-green-100 text-green-800 border border-green-200' 
        : 'bg-red-100 text-red-800 border border-red-200'
    }`
    feedback.textContent = message
    feedback.style.opacity = '0'
    feedback.style.transform = 'translateY(-10px)'
    
    document.body.appendChild(feedback)
    
    // Animate in
    requestAnimationFrame(() => {
      feedback.style.opacity = '1'
      feedback.style.transform = 'translateY(0)'
    })
    
    // Remove after delay
    setTimeout(() => {
      feedback.style.opacity = '0'
      feedback.style.transform = 'translateY(-10px)'
      setTimeout(() => {
        if (document.body.contains(feedback)) {
          document.body.removeChild(feedback)
        }
      }, 300)
    }, 2000)
  }
}